import React, { Component } from 'react';
import { PilotlyLogo } from '../global/base64logo';

export default class PageLoader extends Component {
	render() {
		const styleClass = (this.props.addedClass ? this.props.addedClass : "") + " loader-layer";

		let radius = "22";
		if (this.props.radius) {
			radius = this.props.radius;
		}

		if(this.props.small) {
			return (
				<div className={styleClass + " small-loader"} style={{display: this.props.loading ? "block" : "none"}}>
					<div className="loader-box small">
						<svg className="circular" width="50">
							<circle className="path" cx="50" cy="50" r={radius}
								fill="none" strokeWidth="3" strokeMiterlimit="20"/>
						</svg>
					</div>
				</div>
			);

		} else {
			return (
				<div className={styleClass} style={{display: this.props.loading ? "block" : "none"}}>
					<div className="loader-box">
						<svg className="circular" viewBox="25 25 50 50">
							<circle className="path" cx="50" cy="50" r="22"
								fill="none" strokeWidth="3" strokeMiterlimit="20"/>
						</svg>
						<div className="play-logo">
							<img src={PilotlyLogo} alt="Pilotly Logo" />
						</div>
					</div>
				</div>
			);
		}
	}
}


// WEBPACK FOOTER //
// ./src/components/global/PageLoader.js